module.exports = __webpack_public_path__ + "public/img/BLINKL-LOGO-WHITE.3dfdb317.svg";